import { gql } from 'graphql-request';
import { Marker } from 'src/shared/types';

export const markersQuery = gql`
    query markers($projectId: String!, $sampleId: String!) {
        markers(projectId: $projectId, sampleId: $sampleId) {
            assayId
            numberNamedSpecies
            numberSpeciesDetected
            results {
                taxonomy {
                    tax_species
                }
                conservationStatus
                nmSeqId
            }
        }
    }
`;

type MarkersData = Marker[];

export type MarkersQueryResult = {
    markers: MarkersData;
};
